var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKapal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3311 8.87032L5.98565 10.0677M11.3311 8.87032L16.2535 10.0189M11.3311 8.87032L11.3312 12.5469L11.3312 16.2235M15.8889 16.2235L18.0791 11.6972C18.3582 11.1203 18.0302 10.4334 17.4061 10.2878L16.2535 10.0189M15.8889 16.2235H11.3312M15.8889 16.2235H20.6898M15.8889 16.2235H6.77341M6.77341 16.2235L4.35915 11.7331C4.04559 11.1499 4.3752 10.4284 5.02134 10.2837L5.98565 10.0677M6.77341 16.2235H11.3312M6.77341 16.2235H1.31006M5.98565 10.0677V6.46719C5.98565 5.9149 6.43336 5.46719 6.98565 5.46719H9.32574M16.2535 10.0189V6.46719C16.2535 5.9149 15.8058 5.46719 15.2535 5.46719H13.0327M9.32574 5.46719V1.63867H13.0327V5.46719M9.32574 5.46719H13.0327M5.19337 19.3228H17.0435M7.68494 22.3613H13.8227",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKapal);
export default __webpack_public_path__ + "static/media/kapal.8beb28fe530740aced26379ec3b01dfb.svg";
export { ForwardRef as ReactComponent };